import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './monProfil.css';
import jwt_decode from 'jwt-decode';
import { Link, Redirect } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import './monProfil.css'
import Edit from '../../images/edit.png'
import assidu from '../badge/assidu (2).svg';
import debutant from '../badge/debutant.svg';
import extreme from '../badge/extreme.svg';
import fidèle from '../badge/fid195168le.svg';
import passionné from '../badge/passionn195169.svg';
import orga1 from '../badge/orga1.svg';
import orga2 from '../badge/orga2.svg';
import orga3 from '../badge/orga3.svg';
import orga4 from '../badge/orga4.svg';
import orga5 from '../badge/orga5.svg';
import Plume from '../../images/quill.png'


const MonProfil = ({ match }) => {

  const [monProfil, setMonProfil] = useState({
    firstname: '',
    lastname: '',
    pseudo: '',
    password: '',
    birthday: '',
    city: '',
    phone: '',
    inscription_date: '',
    description: '',
    hobbies: '',
    profil_pic: '',
    mail: ''
  })

  const [image, setImage] = useState(null)
  const [id, setId] = useState('')
  const [modal, setModal] = useState(false);
  const [test, setTest] = useState('')

  const toggle = () => setModal(!modal);

  const [modalDesc, setModalDesc] = useState(false);
  const toggleDesc = () => setModalDesc(!modalDesc);

  const readUri = (e) => {
    let reader = new FileReader()
    reader.onload = (ev) => {
      setTest(ev.target.result)
    }
    reader.readAsDataURL(e.target.files[0]);
  }

  const { params: { fbId } } = match;

  useEffect(() => {
    getInfo()
    getId()

  }, [id, monProfil.profil_pic])
  

  const onClickHandler = (e) => {
    e.preventDefault()
    const data = new FormData()
    data.append('file', image[0])
    axios.put(`https://clean-my-calanques.herokuapp.com/upload/profilPic/${id}`, data)
      .then(res => {
        console.log(res.statusText)

      })

  }

  const getInfo = () => {
    axios.get(`https://clean-my-calanques.herokuapp.com/user/${id}`)
      .then(response => setMonProfil(response.data))
      .catch(err => console.error(err))
  }

  const queryData = (e) => {
    e.preventDefault()
    let postProfile = monProfil
    delete postProfile.profil_pic
    onClickHandler(e)
    axios.put(`https://clean-my-calanques.herokuapp.com/user/${id}`, monProfil)
      .catch(err => console.error(err))
      .then(x => setModal(!modal))

  }

  const queryDataDesc = (e) => {
    e.preventDefault()
    axios.put(`https://clean-my-calanques.herokuapp.com/user/${id}`, monProfil)
      .catch(err => console.error(err))
      .then(x => setModalDesc(!modalDesc))
  }

  const onChangeHandler = (e) => {
    setImage(e.target.files)
    console.log(e.target.files[0])
    readUri(e)

  }



  const getId = () => {

    console.log(fbId)
    if (typeof fbId !== "undefined") {
      try { 

        const decodedTry = jwt_decode(fbId);
        if (decodedTry.id !== "undefined") localStorage.setItem('userToken', fbId)
      }
      catch (Error) {
        return (
          <Redirect to="/mappy"></Redirect>
        )
      }
    }

    if (localStorage.userToken) {
      const token = localStorage.userToken
      const decoded = jwt_decode(token)
      setId(decoded.id)
      localStorage.setItem('userId', decoded.id)
      localStorage.setItem('userPriv', decoded.privileges)
    }

    else {
      return (
        <Redirect to="/mappy"></Redirect>
      )
    }
  }





  return (

    <div>

      <div>
        <form onSubmit={queryData} >
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>Informations personnelles</ModalHeader>
            <ModalBody>
              <input placeholder="Prénom" name='firstname' value={monProfil.firstname} type='text' onChange={(e) => setMonProfil({ ...monProfil, firstname: e.target.value })} />
              <input placeholder="Nom" name='lastname' value={monProfil.lastname} type='text' onChange={(e) => setMonProfil({ ...monProfil, lastname: e.target.value })} />
              <input placeholder="Pseudo" name='pseudo' value={monProfil.pseudo} type='text' onChange={(e) => setMonProfil({ ...monProfil, pseudo: e.target.value })} />
              <input placeholder="Date de naissance" name='birthday' value={monProfil.birthday} type='date' onChange={(e) => setMonProfil({ ...monProfil, birthday: e.target.value })} />
              <input placeholder="Ville" name='city' value={monProfil.city} type='text' onChange={(e) => setMonProfil({ ...monProfil, city: e.target.value })} />
              <input placeholder="Télèphone" name='phone' value={monProfil.phone} type='text' onChange={(e) => setMonProfil({ ...monProfil, phone: e.target.value })} />
              <input placeholder="Description" name='description' value={monProfil.description} type='text' onChange={(e) => setMonProfil({ ...monProfil, description: e.target.value })} />
              <form class="uploadContainer" method="POST" encType="multipart/form-data" action="uploaddufichier" >
                <div className="upload-btn-wrapper">
                  <button className="buttonUpload">Ajouter une photo !</button>
                  <input type="file" name="file" onChange={(e) => onChangeHandler(e)} />
                </div>
                <img src={test} style={{ width: '300px', textAlign: 'center', borderRadius: '5px' }} />
                {/* <Button className="btn" type="submit" onClick={(e) => onClickHandler(e)}>Envoyer la photo</Button> */}
                <ModalFooter >
                <Button className="image-btn" type='submit' onClick={(e) => queryData(e)} > Valider</Button>
                </ModalFooter>

              </form>

            </ModalBody>
          </Modal>


        </form>

        <form onSubmit={queryDataDesc} >
          <Modal isOpen={modalDesc} toggle={toggleDesc}>
            <ModalHeader toggle={toggleDesc}>Parle nous de toi !</ModalHeader>
            <ModalBody>
              <input placeholder="Description" name='description' value={monProfil.description} type='text' onChange={(e) => setMonProfil({ ...monProfil, description: e.target.value })} />
              <Button className="image-btn" type='submit' onClick={(e) => queryDataDesc(e)} > Enregistrer</Button>
            </ModalBody>
          </Modal>
        </form>

        <div className="cover-photo">
        <Button className="buttonEdit" onClick={toggle}><img src={Edit} alt="plus" width="40vh" /></Button>
          <p className="firstname">{monProfil.firstname}</p>
          <p className="lastname">{monProfil.lastname}</p>
        </div>
        <div className="photo">
          <img className="img-profil" src={monProfil.profil_pic} />
        </div>

        <div className="statistics">
          <div className="resume">
            <div className="nbr-participation">
              <p>{monProfil.nbr_participation}</p>
              <p>Participation(s)</p>
            </div>
          </div>

          <div className="resume">
            <div className="nbr-organisation">
              <p>{monProfil.nbr_organisation}</p>
              <p>Organisation(s)</p>
            </div>
          </div>

        </div>

        <hr class="hr"/>

        
          
          {monProfil.description ? (<>
            <Button className='buttonPlume plumeActive' onClick={toggleDesc} ><img className='plume' src={Plume} /></Button>
            <div className="participant">
            <p>Ma mini bio</p>
          </div></>)
          : (<>
            <div className="participant">
            <p>Ma mini bio</p>
          </div>
            <Button className='buttonPlume' onClick={toggleDesc} ><img className='plumeAbs' src={Plume} /></Button></>
          )}
          <p>{monProfil.description}</p>
          <hr class="hr"/>

        <div className="badges">

          <div className="participant">
            <p>Badges du Participant</p>
          </div>

          <div className="allBadges">
            <div className={monProfil.nbr_participation < 5 ? 'disableBadge' : 'activateBadge'}>
              <img className='logo-badges1' src={debutant} alt="logo badge" />
            </div>
            <div className={monProfil.nbr_participation < 10 ? 'disableBadge' : 'activateBadge'}>
              <img className='logo-badges2' src={assidu} alt="logo badge" />
            </div>
            <div className={monProfil.nbr_participation < 15 ? 'disableBadge' : 'activateBadge'}>
              <img className='logo-badges3' src={passionné} alt="logo badge" />
            </div>
            <div className={monProfil.nbr_participation < 20 ? 'disableBadge' : 'activateBadge'}>
              <img className='logo-badges4' src={fidèle} alt="logo badge" />
            </div>
            <div className={monProfil.nbr_participation < 30 ? 'disableBadge' : 'activateBadge'}>
              <img className='logo-badges5' src={extreme} alt="logo badge" />
            </div>
          </div>

          <div className="participant">
            <p>Badges de l'Organisateur</p>
          </div>

          <div className="allBadges">
            <div className={monProfil.nbr_organisation < 4 ? 'disableBadge' : 'activatebadge'}>
              <img className='logo-orga1' src={orga1} alt="logo badge1" />
            </div>
            <div className={monProfil.nbr_organisation < 10 ? 'disableBadge' : 'activatebadge'}>
              <img className='logo-orga2' src={orga2} alt="logo badge2" />
            </div>
            <div className={monProfil.nbr_organisation < 15 ? 'disableBadge' : 'activatebadge'}>
              <img className='logo-orga3' src={orga3} alt="logo badge3" />
            </div>
            <div className={monProfil.nbr_organisation < 20 ? 'disableBadge' : 'activatebadge'}>
              <img className='logo-orga4' src={orga4} alt="logo badge4" />
            </div>
            <div className={monProfil.nbr_organisation < 25 ? 'disableBadge' : 'activatebadge'}>
              <img className='logo-orga5' src={orga5} alt="logo badge5" />
            </div>
          </div>
        </div>

      </div>
    </div>


  )
}

export default MonProfil;